// extracted by mini-css-extract-plugin
export default {"innerWrapper":"VB-z","tooltipWrapper":"WB-z","icon":"XB-z","tooltip":"YB-z","content":"ZB-z"};